module.exports = __webpack_public_path__ + "img/background-video-slider-lincoln.84d87798.jpg";